<div [ngClass]="getClassType()">
  <div class="alert-content">
    <div class="alert-title">
      @if (alertType) {
        <img class="ticons" alt="{{ altText }}" src="{{ imagePath }}" />
      }
      @if (showAlertName) {
        <div class="alert-name">{{ alertName }}</div>
      }
    </div>
    <div class="sysque-alert-text" [innerHTML]="message"></div>
  </div>
  @if (isDissmisible) {
    <img class="ticonsX" alt="close" src="assets/img/close.png" (click)="onDismissClick()" />
  }
</div>
